import { render, staticRenderFns } from "./IconSupportArrow.vue?vue&type=template&id=e7665202"
import script from "./IconSupportArrow.vue?vue&type=script&lang=js"
export * from "./IconSupportArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports